import type { IntlService } from 'ember-intl';
import type LabelService from 'volta/services/label-service';

import Helper from '@ember/component/helper';
import { observer } from '@ember/object';
import { service } from '@ember/service';

interface UnitMeasureSignature {
  Args: {
    Positional: [unit: string | undefined | null];
  };
  Return: string;
}

export default class UnitMeasure extends Helper<UnitMeasureSignature> {
  @service intl!: IntlService;
  @service labelService!: LabelService;

  // eslint-disable-next-line ember/no-observers
  onLocaleChange = observer('intl.locale', () => {
    this.recompute();
  });

  compute([unit]: [string | undefined]) {
    return this.labelService.unitMeasure(unit);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'unit-measure': typeof UnitMeasure;
  }
}
